<template>
  <div v-if="paymentGateway.methods.giftCard">
    <div
      v-if="giftCards.length > 0"
      class="section section--half-y-padding"
    >
      <div class="layout layout--horizontal">
        <h3 class="title title--6 grow">
          Gift Cards
        </h3>

        <button
          class="button button--small button--icon button--secondary"
          type="button"
          title="Add Gift Card"
          :disabled="!canApplyGiftCards"
          @click="$openModal('addGiftCard')"
        >
          <span class="icon far fa-plus" />
        </button>
      </div>

      <div class="card-list card-list--clickable">
        <label
          v-for="card in giftCards"
          :key="card.cardNumber"
          :class="[
            'card-list__item',
            { 'card-list__item--disabled': !card.isApplied && !canApplyGiftCards }
          ]"
          :for="`selectedGiftCard${card.cardNumber}`"
        >
          <div class="card-list__item-section">
            <card-type-icon
              payment-type="GiftCard"
              :card-design-url="card.design.url"
            />

            <p class="title title--6 dark">
              •••• {{ card.cardNumberLastFour }}
            </p>
          </div>

          <div class="card-list__item-section">
            <p class="smaller">
              Card Balance: {{ $dollars(card.amount) }}
            </p>

            <div class="checkbox-input checkbox-input--default checkbox-input--no-label-text">
              <div class="checkbox-input__option">
                <input
                  :id="`selectedGiftCard${card.cardNumber}`"
                  class="checkbox-input__input"
                  type="checkbox"
                  name="selectedGiftCard"
                  :disabled="!card.isApplied && !canApplyGiftCards"
                  :checked="card.isApplied"
                  @input="inputHandler(card)"
                >

                <div class="checkbox-input__label" />
              </div>
            </div>
          </div>
        </label>
      </div>

      <slot name="below-listed-cards" />
    </div>

    <!-- Modals -->
    <modal
      name="addGiftCard"
      modal-style="compact"
    >
      <div class="section section--half-padding">
        <button
          class="link link--has-title"
          type="button"
          tabindex="-1"
          @click="$closeModal('addGiftCard')"
        >
          <div class="layout layout--icon layout--icon-extra-spacing">
            <span class="icon icon--smedium far fa-arrow-left dark-gray" />
            <h2 class="title title--2">
              {{ addGiftCardContent.title }}
            </h2>
          </div>
        </button>
      </div>

      <div class="section section--alt-background section--half-padding">
        <p>
          {{ addGiftCardContent.description }}
        </p>
        <add-gift-card :payment-gateway="paymentGateway" />
      </div>
    </modal>
  </div>
</template>

<script>
  import errorHandlers from '@/services/error-handlers';
  import AddGiftCard from './add-gift-card.vue';
  import { mapGetters } from 'vuex';

  export default {
    name: 'GiftCards',

    components: {
      AddGiftCard
    },

    props: {
      paymentGateway: {
        type: Object,
        required: true
      },
      canApplyGiftCards: {
        type: Boolean,
        required: true
      },
      giftCards: {
        type: Array,
        required: true
      }
    },

    computed: {
      ...mapGetters('session', ['session']),
      ...mapGetters('content', ['content']),

      addGiftCardContent() {
        const content = this.content.AddGiftCardAtCheckout;

        return {
          title: content.title,
          description: content.description
        };
      }
    },

    created() {
      this.createdHandler();
    },

    methods: {
      async createdHandler() {
        if (this.session.isSignedIn) {
          try {
            await this.$store.dispatch('giftCards/getSavedCards', { allowCache: false });
          }
          catch (error) {
            errorHandlers.silent(error);
          }
        }
      },

      inputHandler(giftCard) {
        const mutation = giftCard.isApplied
          ? 'giftCards/REMOVE_APPLIED_CARD_NUMBER'
          : 'giftCards/ADD_APPLIED_CARD_NUMBER';

        this.$store.commit(mutation, giftCard.cardNumber);
      }
    }
  };
</script>
